import { ArrowLeft } from "lucide-react";
import { RateValue } from "@/components/admin/VendorDetail";

const GroupRow = ({ label, span }) => (
  <tr><td className="hx-group" colSpan={span}>{label}</td></tr>
);

export const VendorCompare = ({ subs, onBack }) => {
  const span = subs.length + 2;
  const rooms = subs[0].rooms;
  const services = subs[0].services;
  const roomOf = (s, id) => s.rooms.find((r) => r.id === id);
  const svcOf = (s, id) => s.services.find((x) => x.id === id);

  return (
    <div className="hx-fade" data-testid="vendor-compare">
      <div className="hx-toolbar">
        <button className="hx-btn hx-btn--ghost hx-btn--sm" onClick={onBack} data-testid="vendor-compare-back-button"><ArrowLeft size={14} /> All submissions</button>
        <span className="hx-muted">Comparing {subs.length} vendor{subs.length === 1 ? "" : "s"}</span>
      </div>
      <div className="hx-scroll">
        <table className="hx-table hx-compare" data-testid="vendor-compare-table">
          <thead>
            <tr>
              <th>Item</th>
              <th>Our Est.</th>
              {subs.map((s) => <th key={s.submission_id} className="hx-vendor-col" data-testid={`compare-col-${s.submission_id}`}>{s.vendor.company_name}</th>)}
            </tr>
          </thead>
          <tbody>
            <GroupRow label="Room Packages" span={span} />
            {rooms.map((r) => (
              <tr key={r.id}>
                <td><div className="hx-strong">{r.label}</div><div className="hx-muted">{r.size}</div></td>
                <td className="hx-est">{r.our_estimate}</td>
                {subs.map((s) => <td key={s.submission_id} data-testid={`compare-cell-${r.id}-${s.submission_id}`}><RateValue room={roomOf(s, r.id) || {}} /></td>)}
              </tr>
            ))}
            <GroupRow label="Additional Services" span={span} />
            {services.map((sv) => (
              <tr key={sv.id}>
                <td>{sv.label}</td>
                <td className="hx-est">{sv.our_estimate}</td>
                {subs.map((s) => <td key={s.submission_id} className="hx-strong" data-testid={`compare-cell-${sv.id}-${s.submission_id}`}>{svcOf(s, sv.id)?.rate || "—"}</td>)}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
